import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import colors from 'config/colors';

// The one summary card across the dashboard (the look of the App usage cards): a real card with its own border, a thin coloured top
// edge, a very soft tint, a small caps label over a big figure and an optional note. With `onClick` it is a button that filters what
// is below; the chosen one gets a ring. tone: neutral | good | warn | bad | info (income / expense are the same as good / bad).
export const TONE_COLORS = {
  neutral: colors.accent,
  good: '#2e7d32',
  income: '#2e7d32',
  warn: '#b26a00',
  bad: '#c62828',
  expense: '#c62828',
  info: '#1565c0',
};

const StatTile = ({
  label,
  value,
  tone = 'neutral',
  note,
  loading,
  onClick,
  active,
  minWidth = 140,
  maxWidth,
  compact = false,
  inline = false,
  style,
}) => {
  const color = TONE_COLORS[tone] || TONE_COLORS.neutral;
  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={e => onClick && e.key === 'Enter' && onClick()}
      style={{
        flex: '1 1 0',
        minWidth,
        maxWidth,
        background: active
          ? `linear-gradient(180deg, ${color}26 0%, #fff 85%)`
          : `linear-gradient(180deg, ${color}18 0%, #fff 80%)`,
        borderRadius: 12,
        // per-side longhands only: a `border` shorthand that changes with `active` would silently reset the thicker top edge
        borderStyle: 'solid',
        borderWidth: '3px 1px 1px 1px',
        borderTopColor: `${color}cc`,
        borderRightColor: active ? `${color}aa` : `${color}40`,
        borderBottomColor: active ? `${color}aa` : `${color}40`,
        borderLeftColor: active ? `${color}aa` : `${color}40`,
        padding: compact ? '7px 12px 9px' : '12px 14px 14px',
        ...(inline && { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }),
        cursor: onClick ? 'pointer' : 'default',
        // a chosen card only gets a firmer border and a little more shadow - no ring, so the card's own style is kept
        boxShadow: active ? '0 3px 12px rgba(0,0,0,0.12)' : '0 1px 6px rgba(0,0,0,0.08)',
        transition: 'box-shadow .15s',
        ...style,
      }}>
      {loading ? (
        <>
          <Skeleton variant="text" width="60%" height={14} animation="wave" />
          <Skeleton variant="text" width="45%" height={26} animation="wave" />
        </>
      ) : (
        <>
          <div
            style={{
              fontSize: 11,
              color: '#6b778a',
              marginBottom: inline ? 0 : compact ? 3 : 6,
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}>
            {label}
          </div>
          <div style={{ fontSize: compact ? 20 : 24, fontWeight: 'bold', lineHeight: 1.1, color }}>{value}</div>
          {note && <div style={{ fontSize: 11, color: '#8b95a1', marginTop: 4 }}>{note}</div>}
        </>
      )}
    </div>
  );
};

export default StatTile;
